import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogsProfissionaisService {

  private readonly path = 'profissionais';
  public params = new HttpParams();

  constructor(private apiService: ApiService) { }

  list(params?: any): Observable<any> {
    return this.apiService
      .get<{}>(
        `${this.path}/AtivityLogs`,
        params
          ? new HttpParams({
            fromObject: params,
          })
          : this.params,
        true // <- força o uso da URL secundária
      )
      .pipe(
        // debounceTime(500),
        map((response) => response)
      );
  }

  show(logID: string): Observable<any> {
    return this.apiService
      .get<{}>(
        `${this.path}/AtivityLogs/${logID}`,
        this.params,
        true // <- força o uso da URL secundária
      )
      .pipe(map((response) => response));
  }
}
